<template>
  <div class="home">
    <el-container>
      <el-header>
        <div class="header-wrapper">
          <img src="@/assets/home/logo.png" alt="" class="logo" />
          <ul class="nav">
            <li
              :class="{ active: navIndex == index }"
              v-for="(item, index) in navList"
              :key="index"
              @click="handleClickNav(item, index)"
            >
              <a>{{ item.text }}</a>
            </li>
          </ul>
          <p class="mobile">合作热线 &nbsp;&nbsp;<span>4000-187-881</span></p>
        </div>
      </el-header>
      <!-- <el-main> </el-main> -->

      <component
        v-for="item in sectionArr"
        :is="item.component"
        :key="item.id"
        :ref="item.component"
      ></component>

      <el-footer ref="footer">
        <div class="footer-container">
          <div class="chat-msg">
            <div class="chat-logo">
              <img src="@/assets/home/footer/logo.png" class="logo" alt="" />
              <p class="text">客服热线</p>
              <p class="chat-phone">4000-187-881</p>
            </div>
            <div class="time">
              <img src="@/assets/home/footer/workinghours.png" class="workinghours" alt="" />
              <p>周一到周日</p>
              <p class="time-msg">11:00-24:00</p>

              <img src="@/assets/home/footer/CompanyAddress.png" class="company-address" alt="" />
              <p>国金惠农店-五一广场惠农大厦kfc旁</p>
              <p>解放西路店-皇后酒吧对面</p>
            </div>
          </div>
          <div class="code">
            <img src="@/assets/home/footer/2.png" alt="" />
            <img src="@/assets/home/footer/3.png" alt="" />
            <img src="@/assets/home/footer/1.png" alt="" />
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import section1 from "./section/section1.vue";
import section2 from "./section/section2.vue";
import section3 from "./section/section3.vue";
import section4 from "./section/section4.vue";
import section5 from "./section/section5.vue";
import section6 from "./section/section6.vue";
import section7 from "./section/section7.vue";

export default {
  // seo信息
  metaInfo: {
    title: "Ahabox盲盒咖咖官方网站-盲盒咖啡-有家创造惊喜的咖啡店",
    meta: [
      {
        name: "keyWords",
        content: "Ahabox盲盒咖咖官方网站-盲盒咖啡-有家创造惊喜的咖啡店",
      },
      {
        name: "description",
        content: "Ahabox盲盒咖咖官方网站-盲盒咖啡-有家创造惊喜的咖啡店",
      },
    ],
  },
  name: "Home",
  components: {},
  data() {
    return {
      navIndex: 0,
      navList: [
        { id: 1, text: "首页", link: "section1" },
        { id: 2, text: "品牌介绍", link: "section2" },
        { id: 3, text: "产品中心", link: "section3" },
        { id: 4, text: "品牌合作", link: "section6" },
        { id: 5, text: "联系我们", link: "footer" },
      ],
      sectionArr: [
        { id: 1, component: "section1" },
        { id: 2, component: "section2" },
        { id: 3, component: "section3" },
        { id: 4, component: "section4" },
        { id: 5, component: "section5" },
        { id: 6, component: "section6" },
        { id: 7, component: "section7" },
      ],
    };
  },
  components: {
    section1,
    section2,
    section3,
    section4,
    section5,
    section6,
    section7,
  },

  methods: {
    handleClickNav(item, i) {
      this.navIndex = i;
      if (item.id === 5) {
        this.$refs.footer.$el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } else {
        this.$refs[item.link][0].$el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  background-color: #e6328d;
  color: #333;
  text-align: center;
  // line-height: 60px;
  height: 80px !important;
  min-width: 1150px;
  .header-wrapper {
    max-width: 1600px;
    min-width: 1150px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 80px;
    .logo {
      width: 215px;
      height: 40px;
    }
    .nav {
      display: flex;
      // max-width: 983px;
      width: 983px;
      color: #fff;
      margin: 0 auto;
      margin-left: 100px;
      margin-right: 100px;
      justify-content: space-between;
      a {
        font-size: 16px;
      }
      li {
        position: relative;
        cursor: pointer;
        transition: 0.3s;
      }
      li:hover {
        // color: rgb(245, 245, 84);
        transform: scale(1.1);
      }
      .active::after {
        content: "";
        position: absolute;
        left: 50%;
        margin-left: -10px;
        right: -5px;
        bottom: -10px;
        width: 20px;
        height: 2px;
        background-color: #fff;
      }
    }
    .mobile {
      color: #fff;
      white-space: nowrap;
      span {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
}

.el-main {
  padding: 0;
  width: 100%;
}

.el-footer {
  padding: 0;
  background: #e6328d;
  height: 380px !important;
  .footer-container {
    // width: 1600px;
    height: 160px;
    margin: 0 auto;
    margin-top: 110px;
    display: flex;
    justify-content: space-between;
    .chat-msg {
      width: 720.58px;
      height: 160px;
      text-align: left;
      display: flex;
      justify-content: space-between;

      .chat-logo {
        .logo {
          width: 320px;
          height: 60px;
        }
        .text {
          font-size: 16px;
          line-height: 18px;
          color: #ffffff;
          margin-top: 24px;
        }

        .chat-phone {
          font-size: 51px;
          font-weight: bold;
          color: #ffffff;
          margin-top: 16px;
        }
      }

      .time {
        width: 280.58px;
        height: 160px;
        .time-img {
          width: 166px;
          height: 80px;
        }
        .workinghours {
          width: 116px;
          // height: 8px;
        }
        .company-address {
          width: 133px;
          // height: 8px;
          margin-top: 16px;
        }

        .time-msg {
          font-size: 36px;
          font-weight: bold;
          line-height: 36px;
          color: #ffffff;
          margin-top: 16px;
        }
        p {
          font-size: 16px;
          margin-top: 8px;

          color: #ffffff;
        }
      }
    }
    .code {
      width: 618px;
      height: 160px;
      justify-content: space-between;
      display: flex;
      img {
        width: 160px;
        height: 160px;
      }
    }
  }
}

@media (min-width: 1201px) and (max-width: 1616px) {
  .footer-container {
    width: 95%;
    .img-wrapper {
      width: 100%;
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .footer-container {
      width: 1600px;
    }
  }

  @media (max-width: 1200px) {
    .el-footer {
      width: 1200px;
      .footer-container {
        width: 1083px;
        .chat-msg {
          width: 571.58px;
          height: 160px;
          .chat-logo {
            .logo {
              width: 270px;
              height: 50.63px;
            }
            .text {
              font-size: 16px;
              line-height: 18px;
              color: #ffffff;
              margin-top: 36px;
            }

            .chat-phone {
              font-size: 43px;
              font-weight: bold;
              color: #ffffff;
              margin-top: 16px;
            }
          }

          .time {
            width: 280.58px;
            height: 160px;
            margin-left: 20px;
            .time-img {
              width: 166px;
              height: 80px;
            }
            .workinghours {
              width: 116px;
              // height: 8px;
            }
            .company-address {
              width: 133px;
              // height: 8px;
              margin-top: 16px;
            }

            .time-msg {
              font-size: 36px;
              font-weight: bold;
              line-height: 36px;
              color: #ffffff;
              margin-top: 16px;
            }
            p {
              font-size: 16px;
              margin-top: 8px;

              color: #ffffff;
            }
          }

          .code {
            width: 510px;
            height: 150px;
            justify-content: space-between;
            display: flex;
            img {
              width: 150px;
              height: 150px;
            }
          }
        }
      }
    }
  }
}
</style>
